import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class StartupService {
  constructor(private http: HttpClient) {}

  getAppOktaUrls(): Promise<boolean> {
    return new Promise((resolve) => {
      this.http.get(`/api/get_app_okta_urls`).subscribe(
        (data: any) => {
          window.caUrl = data.CA_URL.slice(0, -1);
          window.apiUrl = window.location.origin;
          window.assetUrl = environment.assetUrl;
          window.projectArkUrl = data.PROJECT_ARK_URL.slice(0, -1);
          window.sellsideApiUrl = window.location.origin;
          resolve(true);
        },
        (error) => {
          console.error(error);
          window.caUrl = environment.legacyDomain;
          window.apiUrl = environment.apiUrl;
          window.assetUrl = environment.assetUrl;
          window.projectArkUrl = environment.apiUrl;
          window.sellsideApiUrl = environment.sellsideApiUrl;
          resolve(false);
        },
      );
    });
  }
}
